export default __webpack_public_path__ + "static/Roc-Grotesk-Bold-65e3669d1d047598120052091a5ba1df.otf";